// @flow
import React, {useEffect} from 'react';
import type {Node} from 'react';
import {OutlinedInput} from '@mui/material';
import {Select} from '@wellstone-solutions/web';
import {Modules} from '@wellstone-solutions/common';
import type {UIRecurrenceType} from '@wellstone-solutions/common';

type PropsType = {
  form?: mixed,
  onChange: (UIRecurrenceType) => void,
  recurrence: UIRecurrenceType,
  startDate: string,
};

export const DaysOfMonth = ({
  form,
  recurrence,
  startDate,
  onChange,
}: PropsType): Node => {
  const {useMonthlySelect} = Modules.Schedule;
  const {items, valueKey, valueMap} = useMonthlySelect({
    recurrence,
    startDate,
  });

  /* useMonthlySelect is running multiple times and last instance is finishing
   after the change handler returns. So the form isn't updated properly. 
   Setting it with the useEffect when the valueKey updates solves this.
*/
  useEffect(() => {
    if (form) {
      form.setFieldValue('recurrence', {...recurrence, ...valueMap[valueKey]});
    }
  }, [valueKey]);

  return (
    <Select
      data-testid="days-of-month"
      canUnselect={false}
      input={<OutlinedInput notched={false} />}
      items={items}
      value={valueKey}
      inputProps={{sx: {backgroundColor: '#FFF'}}}
      onChange={(e) => {
        onChange({
          ...recurrence,
          ...valueMap[e.target.value],
        });
      }}
    />
  );
};
